import { render } from "./AncillaryFlightsListView.vue?vue&type=template&id=2b2dafc3&scoped=true"
import script from "./AncillaryFlightsListView.vue?vue&type=script&lang=js"
export * from "./AncillaryFlightsListView.vue?vue&type=script&lang=js"

import "./AncillaryFlightsListView.vue?vue&type=style&index=0&id=2b2dafc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2dafc3"]])

export default __exports__